// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AlertsRouteImport } from './routes/alerts'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EventsRouteImport } from './routes/events'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NewsRouteImport } from './routes/news'
import { Route as PropertiesRouteImport } from './routes/properties'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SavedSearchesRouteImport } from './routes/saved-searches'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as AboutSlugRouteImport } from './routes/about/$slug'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminSectionRouteImport } from './routes/admin/$section'
import { Route as BrochureSlugRouteImport } from './routes/brochure.$slug'
import { Route as MyListingsIndexRouteImport } from './routes/my-listings/index'
import { Route as MyListingsNewRouteImport } from './routes/my-listings/new'
import { Route as PropertySlugRouteImport } from './routes/property.$slug'
import { Route as MyListingsIdEditRouteImport } from './routes/my-listings/$id/edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AlertsRoute = AlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const PropertiesRoute = PropertiesRouteImport.update({
            id: '/properties',path: '/properties',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const SavedSearchesRoute = SavedSearchesRouteImport.update({
            id: '/saved-searches',path: '/saved-searches',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const AboutSlugRoute = AboutSlugRouteImport.update({
            id: '/about/$slug',path: '/about/$slug',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminSectionRoute = AdminSectionRouteImport.update({
            id: '/admin/$section',path: '/admin/$section',getParentRoute: () => rootRouteImport
          })
const BrochureSlugRoute = BrochureSlugRouteImport.update({
            id: '/brochure/$slug',path: '/brochure/$slug',getParentRoute: () => rootRouteImport
          })
const MyListingsIndexRoute = MyListingsIndexRouteImport.update({
            id: '/my-listings/',path: '/my-listings/',getParentRoute: () => rootRouteImport
          })
const MyListingsNewRoute = MyListingsNewRouteImport.update({
            id: '/my-listings/new',path: '/my-listings/new',getParentRoute: () => rootRouteImport
          })
const PropertySlugRoute = PropertySlugRouteImport.update({
            id: '/property/$slug',path: '/property/$slug',getParentRoute: () => rootRouteImport
          })
const MyListingsIdEditRoute = MyListingsIdEditRouteImport.update({
            id: '/my-listings/$id/edit',path: '/my-listings/$id/edit',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,AlertsRoute: AlertsRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,EventsRoute: EventsRoute,FavoritesRoute: FavoritesRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,NewsRoute: NewsRoute,PropertiesRoute: PropertiesRoute,RegisterRoute: RegisterRoute,SavedSearchesRoute: SavedSearchesRoute,SearchRoute: SearchRoute,SitemapRoute: SitemapRoute,AboutSlugRoute: AboutSlugRoute,AdminSectionRoute: AdminSectionRoute,BrochureSlugRoute: BrochureSlugRoute,MyListingsNewRoute: MyListingsNewRoute,PropertySlugRoute: PropertySlugRoute,AboutIndexRoute: AboutIndexRoute,AdminIndexRoute: AdminIndexRoute,MyListingsIndexRoute: MyListingsIndexRoute,MyListingsIdEditRoute: MyListingsIdEditRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)